import { render, staticRenderFns } from "./BankaccountsList.vue?vue&type=template&id=1b846c64&"
import script from "./BankaccountsList.vue?vue&type=script&lang=js&"
export * from "./BankaccountsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports